import { getConfigObject, useMutationWithLoading } from "../../utils/utils";

import { TwoFactorAuthenticationApi, Verify2FARequest } from "../../services";

/**
 * @author Atish Bagate
 */
export const useVerify2FA = () => {
  return useMutationWithLoading(async (params: { verify2FARequest: Verify2FARequest, xTENANTID?: string }) => {
    const response = await new TwoFactorAuthenticationApi(getConfigObject()).verify2FA(
        params.verify2FARequest,
        params.xTENANTID
    );
    return response;
  }); 
};